<script setup lang="ts">
import type { CmsElementAdvantagesHeadlineIcons } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementAdvantagesHeadlineIcons;
}>();

const { headlineText, Rows } = props.content.data;
</script>

<template>
  <div class="cust-sec-2 bg-c-light-grey px-4">
    <div class="container mx-auto">
      <div
        class="flex flex-col lg:flex-row justify-between relative py-14 sm:py-20"
      >
        <div class="w-full mb-8 lg:mb-0 lg:w-[285px]">
          <div class="title">
            <h3 class="h3-font font-bold leading-tight text-chinese-black">
              {{ headlineText }}
            </h3>
          </div>
        </div>

        <div class="w-full lg:w-[895px]">
          <div class="cust-col-grid">
            <div v-for="(item, index) in Rows" :key="index" class="col-span-1">
              <div
                class="inner-wrap flex"
                :class="{ 'justify-end': index % 2 !== 0 }"
              >
                <div
                  v-if="item.iconImage"
                  class="icon w-[50px] h-[50px] md:w-[60px] md:h-[60px] flex justify-center items-center bg-red-bg rounded-full"
                >
                  <figure>
                    <img
                      v-if="item.iconImage.media"
                      :src="item.iconImage.media.url"
                      :alt="item.iconImage.media.alt ?? 'heart-icon'"
                      width="36px"
                      height="36px"
                      class="w-[48px] h-[48px] md:w-[58px] md:h-[58px]"
                    />
                  </figure>
                </div>

                <div class="content w-[calc(100%-70px)] lg:w-[303px] ml-5">
                  <h5 v-if="item.rowTitle" class="font-bold mb-2">
                    {{ item.rowTitle }}
                  </h5>
                  <div
                    v-if="item.rowText"
                    class="text-sm font-normal"
                    v-html="item.rowText"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
::v-deep(a) {
  text-decoration: underline !important;
}
::v-deep(a:hover) {
  color: #f87171 !important;
}
</style>
